import { useMemo } from 'react';
import { useCurrentOrg } from './useCurrentOrg';
import { has } from 'lodash';

export function useIsOrgFeatureEnabled(featureName: string) {
  const currentOrg = useCurrentOrg();

  return useMemo(() => {
    if (!currentOrg || !has(currentOrg, 'features_enabled')) return null;
    const features_enabled = currentOrg.features_enabled;

    if (!features_enabled) return false;
    if (Array.isArray(features_enabled)) {
      return features_enabled.includes(featureName);
    } else if (typeof features_enabled === 'string') {
      return features_enabled === featureName;
    }

    return false;
  }, [currentOrg, featureName]);
}
